import { OptimizelyBlockExpandedValue } from "../expanded";

export const isSpaceFillerBlock = (
    block: OptimizelyBlockExpandedValue
): block is OptimizelyBlockExpandedValue => {
    return block.contentType[1] === "SpaceFiller";
};
